import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const CreacionTrasladoAlmacenApi = () => {
    const [cargando, setCargando] = useState(false);

    const getAlmacenDetalle = async (almacenId) => {
        try {
            setCargando(true);
            const response = await api.get(`bodega/${almacenId}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getAlmacenesVaciado = async (params) => {
        return api
            .get("traslados_almacen/get_almacenes_destino", params)
            .then((data) => {
                if (data) return data;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getMovimientosAlmacen = async (almacenId, params) => {
        try {
            setCargando(true);
            const response = await api.get(
                `traslados_almacen/ingresos_periodo/${almacenId}`,
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const trasladarMovimiento = async (data) => {
        try {
            setCargando(true);

            const response = await api.post(
                "traslados_almacen/trasladar_movimiento",
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getAlmacenDetalle,
        getAlmacenesVaciado,
        getMovimientosAlmacen,
        trasladarMovimiento,

        cargando,
    };
};
